
import { ConsultorioData } from '@/types/consultorio';

export const consultorios: ConsultorioData[] = [
  {
    id: 1,
    consultorioId: "paulista",
    name: "Consultório Paulista",
    address: "Av. Paulista, 807 - conj 1001 - Bela Vista",
    city: "São Paulo - SP",
    cep: "01311-100",
    complement: "Edifício Sir Winston Churchill",
    phone: "(11) 99887-4081",
    googleMapsUrl: "https://g.co/kgs/fAmGhM2",
    horarios: [
      "Segunda a Sexta: 8h às 18h",
      "Sábado: 8h às 12h"
    ],
    transporte: [
      "Metrô: Estação Trianon-MASP (Linha Verde)",
      "Ônibus: Diversas linhas na Av. Paulista",
      "Estacionamento: Disponível no prédio"
    ],
    servicos: ["Consultas Individuais", "Nutrição Comportamental", "Acompanhamento Online"],
    destaces: ["Localização privilegiada", "Fácil acesso", "Estacionamento no local"],
    photos: [
      "/consultorio-sp/sp1.png",
      "/consultorio-sp/sp2.png",
      "/consultorio-sp/sp3.png",
    ]
  },
  {
    id: 2,
    consultorioId: "mogi",
    name: "Consultório Mogi das Cruzes",
    address: "R. Juvenal Granado Nale, 55 - Centro",
    city: "Mogi das Cruzes - SP",
    cep: "08710-550",
    complement: "",
    phone: "(11) 99887-4081",
    googleMapsUrl: "https://g.co/kgs/2fr2HrG",
    horarios: [
      "Terça e Quinta: 14h às 20h",
      "Sábado: 8h às 14h"
    ],
    transporte: [
      "Trem: Estação Mogi das Cruzes (CPTM)",
      "Ônibus: Terminal Central de Mogi",
      "Estacionamento: Rua lateral gratuito"
    ],
    servicos: ["Consultas Individuais", "Atendimento Familiar", "Nutrição Infantil"],
    destaces: ["Especialidade em nutrição infantil", "Estacionamento gratuito", "Próximo ao terminal"],
    photos: [
      "/consultorio-mogi/mogi1.JPG",
      "/consultorio-mogi/mogi2.JPG",
      "/consultorio-mogi/mogi3.JPG",
    ]
  },
  {
    id: 3,
    consultorioId: "suzano",
    name: "Consultório Suzano",
    address: "R. Paraná, 11 - Edifício Arupati - Centro",
    city: "Suzano - SP",
    cep: "08675-190",
    complement: "",
    phone: "(11) 99887-4081",
    googleMapsUrl: "https://g.co/kgs/K5Z8fJS",
    horarios: [
      "Segunda e Quarta: 14h às 20h",
      "Sábado: 8h às 12h"
    ],
    transporte: [
      "Trem: Estação Suzano (CPTM)",
      "Ônibus: Terminal Suzano",
      "Estacionamento: Disponível nas proximidades"
    ],
    servicos: ["Consultas Individuais", "Nutrição Esportiva", "Acompanhamento Nutricional"],
    destaces: ["Especialidade em nutrição esportiva", "Próximo à estação", "Atendimento especializado"],
    photos: [
      "/consultorio-suzano/suzano1.jpg",
      "/consultorio-suzano/suzano2.jpg",
      "/consultorio-suzano/suzano3.jpg",
    ]
  }
];
